module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Export":"Exporter en Excel","Title":"Rapport des disponibilités de ","OtherOrVaries":"Autre/Divers","InternalFormation":"Interne - Formation"}}')
  delete Component.options._Ctor
}
